import { Icon_GridOutline } from '@urbanx/agx.ui-components2';

interface Props {
  height?: number;
  width?: number;
  padding?: string;
  color?: string;
  opacity?: number;
}

const TasksIcon = (props: Props) => {
  const {
    height = 20,
    width = 20,
    color = '#FFFFFF',
    padding = 'var(--padding-xs)',
    opacity = 1,
  } = props;

  return (
    <div
      style={{
        padding: `${padding}`,
        opacity,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Icon_GridOutline height={height} width={width} color={color} />
    </div>
  );
};
export default TasksIcon;
